import { useState } from 'react'
import { forgotPassword as forgotPasswordService } from '../services/authService';

export const useForgotPassword = () => {
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const forgotPassword = async (email) => {
        setIsLoading(true)
        setError(null)
    try {
        // Convert email to lowercase before sending to the service
        const lowerCaseEmail = email.toLowerCase();
        // console.log('Attempting forgot password request for email:', lowerCaseEmail); // Added log
        const response = await forgotPasswordService(lowerCaseEmail);
        // console.log('Forgot password service response:', response); // Added log

        setIsLoading(false);
        return {success:response.success, message:response.message}
    } catch (error) {
        // console.error('Forgot password request failed:', error); // Log the entire error object
        setIsLoading(false);
        if (error.response) {
            // console.error('Forgot password error response data:', error.response.data); // Log response data
            // console.error('Forgot password error response status:', error.response.status); // Log response status
            return { success: false, message: error.response.data.message || 'An error occurred. Please try again.' };
          } else if (error.request) {
            // console.error('Forgot password error request:', error.request); // Log request object
            return { success: false, message: 'No response from the server. Please check your network connection.' };
          } else {
            // console.error('Forgot password unexpected error:', error.message); // Log unexpected error message
            return { success: false, message: 'An unexpected error occurred. Please try again.' };
          }
    }

  }

  return { forgotPassword, isLoading, error }
}